import { takeLatest, call, put } from 'redux-saga/effects';

import {
  verifyPagePasswordFailure,
  verifyPagePasswordRequest,
  verifyPagePasswordSuccess,
} from '../../slices/user';
import axios from '../axiosConfig';

function* verifyPagePasswordWorker(action) {
  try {
    const { password } = action.payload;
    // oxlint-disable-next-line no-undef
    const data = new FormData();
    data.append('password', password);
    const config = {
      method: 'post',
      url: '/users/verifyPassword',
      data,
      withCredentials: true,
    };
    const response = yield call(axios, config);
    // response.data is true if successful password, base64 encode it and set it as cookie for 1week
    if (response.data && response.data.token) {
      document.cookie = `twpac=${response.data.token};expires=${new Date(Date.now() + response.data.expires_in).toUTCString()};path=/;SameSite=None;Secure`;
    }
    yield put(verifyPagePasswordSuccess({ response: response.data }));
  } catch (e) {
    yield put(verifyPagePasswordFailure('Something went wrong!'));
  }
}

function* verifyPagePasswordWatcher() {
  yield takeLatest(verifyPagePasswordRequest.toString(), verifyPagePasswordWorker);
}

export default verifyPagePasswordWatcher;
